export default __webpack_public_path__ + "static/media/bg-bot.4bef8d6b.svg";